import { resourceActionTypes } from '../actions/types';
import _ from 'lodash';

const initialState = {
  images: [],
  imageSkip: null,
  imageLimit: 16,
  hasMoreImage: true,
  elements: [],
  elementSkip: null,
  elementLimit: 16,
  hasMoreElement: true,
  vectors: [],
  vectorSkip: null,
  vectorLimit: 16,
  hasMoreVector: true,
  frames: [],
  frameSkip: null,
  frameLimit: 16,
  hasMoreFrame: true,
  grids: [],
  gridSkip: null,
  gridLimit: 16,
  hasMoreGrid: true,
  shapes: [],
  shapeSkip: null,
  shapeLimit: 16,
  hasMoreShape: true,
  lines: [],
  lineSkip: null,
  lineLimit: 16,
  hasMoreLine: true,
  texts: [],
  textSkip: null,
  textLimit: 16,
  hasMoreText: true,
  videos: [],
  videoSkip: null,
  videoLimit: 16,
  hasMoreVideo: true,
  backgrounds: [],
  backgroundSkip: null,
  backgroundLimit: 16,
  hasMoreBackground: true,
  userImages: [],
  userImageSkip: null,
  userImageLimit: 16,
  hasMoreUserImage: true,
  userVideos: [],
  userVideoSkip: null,
  userVideoLimit: 16,
  hasMoreUserVideo: true,
  userFolders: [],
  fonts: [],
  fontSkip: null,
  fontLimit: 16,
  hasMoreFont: true,
  uploading: false,
  uploadResult: '',
  multiUploadIndex: null,
  multiUploadTotal: 0,
  deleteResult: '',
  loading: false,
  imageTags: [],
  folderState: null,
};

export function resource(state = initialState, action) {
  switch (action.type) {
    case resourceActionTypes.RESET_STATE:
      return {
        ...initialState,
      };
    case resourceActionTypes.UPLOAD_REQUEST:
      return {
        ...state,
        uploadProgress: _.get(action, 'progress.progress'),
        uploading: true,
        uploadResult: '',
        multiUploadIndex: _.get(action, 'fileIndex.fileIndex'),
        multiUploadTotal: _.get(action, 'fileIndex.total'),
      };
    case resourceActionTypes.UPLOAD_SUCCESS:
      // return {
      //   ...state,
      //   uploading: false,
      //   uploadResult: 'success',
      //   multiUploadIndex: _.get(action, 'resource.fileIndex'),
      //   multiUploadTotal: _.get(action, 'resource.total'),
      // }
      if (action.resource.type === 'Frame' || action.resource.type === 'Shape' || action.resource.type === 'Vector') {
        return {
          ...state,
          uploading: false,
          uploadResult: 'success',
          multiUploadIndex: _.get(action, 'resource.fileIndex'),
          multiUploadTotal: _.get(action, 'resource.total'),
          [`${_.toLower(action.resource.type)}s`]: [action.resource, ...state[`${_.toLower(action.resource.type)}s`]],
          elements: [action.resource, ...state.elements],
        }
      } else {
        return {
          ...state,
          uploading: false,
          uploadResult: 'success',
          multiUploadIndex: _.get(action, 'resource.fileIndex'),
          multiUploadTotal: _.get(action, 'resource.total'),
          [`${_.toLower(action.resource.type)}s`]: [action.resource, ...state[`${_.toLower(action.resource.type)}s`]],
        }
      }
    // if (action.resource.type === 'Image' || action.resource.type === 'Shape' || action.resource.type === 'Vector') {
    //   return {
    //     ...state,
    //     uploading: false,
    //     uploadResult: 'success',
    //     userImages: [action.resource, ...state.userImages],
    //   };
    // } else if (action.resource.type === 'Video') {
    //   return {
    //     ...state,
    //     uploading: false,
    //     userVideos: [action.resource, ...state.userVideos],
    //   };
    // }
    // break;

    case resourceActionTypes.UPLOAD_FAILURE:
      return {
        ...state,
        error: action.error,
        uploading: false,
        uploadResult: 'failed',
      };
    case resourceActionTypes.SEARCH_REQUEST:
      return {
        ...state,
        error: null,
        loading: true,
        [`${action.resourceType.toLowerCase()}Status`]: 'loading',
        [`${action.resourceType.toLowerCase()}Limit`]: action.resourceLimit,
      };
    case resourceActionTypes.SEARCH_SUCCESS: {
      const resourceType = action.resourceType.toLowerCase();
      return {
        ...state,
        [`${resourceType}s`]: action.resources,
        [`${resourceType}Skip`]: action.skip,
        [`${resourceType}Limit`]: action.limit,
        [`${resourceType}Count`]: action.total,
        [`hasMore${action.resourceType}`]: action.skip + action.resources.length < action.total,
        [`${resourceType}Status`]: 'success',
        loading: false,
      };
    }
    case resourceActionTypes.SEARCH_FAILURE:
      return {
        ...state,
        error: action.error,
        [`${action.resourceType.toLowerCase()}Status`]: 'failure',
        loading: false,
      };
    case resourceActionTypes.USER_RESOURCE_REQUEST:
      return {
        ...state,
        error: null,
        loading: true,
      };
    case resourceActionTypes.USER_RESOURCE_SUCCESS:
      switch (action.resourceType) {
        case 'Image':
          return {
            ...state,
            userImages: [...state.userImages, ...action.resources],
            userImageSkip: action.skip,
            userImageLimit: action.limit,
            hasMoreUserImage: action.resources.length !== 0,
            loading: false,
          };
        case 'Video':
          return {
            ...state,
            userVideos: [...state.userVideos, ...action.resources],
            userVideoSkip: action.skip,
            userVideoLimit: action.limit,
            hasMoreUserVideo: action.resources.length !== 0,
            loading: false,
          };
        default:
          return {
            ...state,
            loading: false,
          };
      }
    case resourceActionTypes.USER_RESOURCE_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    case resourceActionTypes.DELETE_REQUEST:
      return {
        ...state,
        deleteResult: '',
        error: null,
        loading: true,
      };
    case resourceActionTypes.DELETE_SUCCESS:
      switch (action.resourceType) {
        case 'UserImage':
          return {
            ...state,
            userImages: action.resources,
            loading: false,
          };
        default:
          return {
            ...state,
            loading: false,
            deleteResult: 'success',
          };
      }
    case resourceActionTypes.DELETE_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
        deleteResult: 'failed',
      };
    case resourceActionTypes.USER_FOLDERS_REQUEST:
      return {
        ...state,
        error: null,
        loading: true,
      };
    case resourceActionTypes.USER_FOLDERS_SUCCESS:
      return {
        ...state,
        userFolders: action.folders ? action.folders : [],
        loading: false,
      };
    case resourceActionTypes.USER_FOLDERS_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    case resourceActionTypes.USER_ACTION_REQUEST:
      return {
        ...state,
        error: null,
        loading: true,
      };
    case resourceActionTypes.USER_ACTION_SUCCESS:
      return {
        ...state,
        loading: false,
        [`${action.resourceType.toLowerCase()}s`]: action.resources,
      };
    case resourceActionTypes.USER_ACTION_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    case resourceActionTypes.USER_FOLDER_RESOURCES_REQUEST:
      return {
        ...state,
        error: false,
        loading: true,
      };
    case resourceActionTypes.USER_FOLDER_RESOURCES_SUCCESS:
      return {
        ...state,
        [`${action.folderName.toLowerCase()}s`]: action.clear
          ? action.resources
          : [..._.get(state, `${action.folderName.toLowerCase()}s`, []), ...action.resources],
        [`${action.folderName}Skip`]: action.skip,
        [`${action.folderName}Limit`]: action.limit,
        [`hasMore${action.folderName}`]: action.resources.length !== 0,
        loading: false,
      };
    case resourceActionTypes.USER_FOLDER_RESOURCES_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    case resourceActionTypes.IMAGE_TAGS_REQUEST:
      return {
        ...state,
        error: action.error,
      };
    case resourceActionTypes.IMAGE_TAGS_SUCCESS:
      return {
        ...state,
        imageTags: action.imageTags,
      };
    case resourceActionTypes.IMAGE_TAGS_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    case resourceActionTypes.CREATE_FOLDER_REQUEST:
      return {
        ...state,
        error: null,
        folderState: 'creating',
      };
    case resourceActionTypes.CREATE_FOLDER_SUCCESS:
      return {
        ...state,
        userFolders: action.folders ? action.folders : [],
        folderState: 'created',
      };
    case resourceActionTypes.CREATE_FOLDER_FAILURE:
      return {
        ...state,
        error: action.error,
        folderState: 'createFailed',
      };
    case resourceActionTypes.ADD_TO_FOLDER_REQUEST:
      return {
        ...state,
        error: null,
        folderState: 'adding',
      };
    case resourceActionTypes.ADD_TO_FOLDER_SUCCESS:
      return {
        ...state,
        [`${action.folderId.toLowerCase()}s`]: [
          ..._.get(state, `${action.folderId.toLowerCase()}s`, []),
          action.resource,
        ],
        folderState: 'added',
      };
    case resourceActionTypes.ADD_TO_FOLDER_FAILURE:
      return {
        ...state,
        error: action.error,
        folderState: 'addFailed',
      };
    case resourceActionTypes.REMOVE_FROM_FOLDER_REQUEST:
      return {
        ...state,
        error: null,
        folderState: 'removing',
      };
    case resourceActionTypes.REMOVE_FROM_FOLDER_SUCCESS:
      return {
        ...state,
        [`${action.folderId.toLowerCase()}s`]: action.resources,
        folderState: 'removed',
      };
    case resourceActionTypes.REMOVE_FROM_FOLDER_FAILURE:
      return {
        ...state,
        error: action.error,
        folderState: 'removeFailed',
      };
    case resourceActionTypes.DELETE_FOLDER_REQUEST:
      return {
        ...state,
        error: null,
        folderState: 'deleting',
      };
    case resourceActionTypes.DELETE_FOLDER_SUCCESS:
      return {
        ...state,
        userFolders: action.folders ? action.folders : [],
        folderState: 'deleted',
      };
    case resourceActionTypes.DELETE_FOLDER_FAILURE:
      return {
        ...state,
        error: action.error,
        folderState: 'deleteFailed',
      };
    case resourceActionTypes.UPDATE_REQUEST:
      return {
        ...state,
        error: null,
        loading: true,
      };
    case resourceActionTypes.UPDATE_SUCCESS:
      const index = state[`${_.lowerCase(action.resource.type)}s`].findIndex(element => element.data.id === action.resource.data.id);
      const updatedList = [...state[`${_.lowerCase(action.resource.type)}s`]];
      updatedList[index] = { ...action.resource, key: updatedList[index].key }
      return {
        ...state,
        [`${_.lowerCase(action.resource.type)}s`]: updatedList,
        loading: false,
      };
    case resourceActionTypes.UPDATE_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    default:
      return state;
  }
}
